import axios from "axios";

export default {
  getNotifications(params = {}) {
    return axios.get('/notifications', { params })
  },
  getUnreadCount() {
    return axios.get(`/notifications/unread-count`)
  },
  read(notificationId) {
    return axios.post(`/notifications/${notificationId}/read`)
  },
  readAll() {
    return axios.post(`/notifications/read-all`);
  },
  async clearAll() {
    return axios.delete('/notifications/clear-all');
  },
};
